import { render, staticRenderFns } from "./iconReglages.vue?vue&type=template&id=957919b2"
import script from "./iconReglages.vue?vue&type=script&lang=js"
export * from "./iconReglages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports